import React from 'react';
import { format } from 'date-fns';
import {
  Container, Distance, Header, Label, Medal, HeaderContainer,
  InfoContainer,
  TitleContainer,
} from './styles';

import { UserVirtualRaceType, VirtualRaceType } from '../../types/VirtualRace';

interface Props {
  virtualRace: VirtualRaceType,
  userVirtualRace?: UserVirtualRaceType
}

export default function VirtualRaceHeader(
  {
    virtualRace, userVirtualRace,
  }: Props,
) {
  const formatDistances = (distances: number[]): string => {
    if (distances.length === 0) return '';
    if (distances.length === 1) return `${distances[0]}KM`;
    if (distances.length === 2) return `${distances[0]}KM e ${distances[1]}KM`;

    const allButLast = distances.slice(0, -1).map((d) => `${d}KM`).join(', ');
    const last = distances[distances.length - 1];
    return `${allButLast} e ${last}KM`;
  };

  return (
    <>
      <Container>

        <Medal src={virtualRace.medal} />
        <HeaderContainer>
          <TitleContainer>
            <Header>{virtualRace.title}</Header>
          </TitleContainer>
          <InfoContainer>
            <div>
              {userVirtualRace ? <Label>Distância</Label> : <Label>Distâncias</Label>}
              {userVirtualRace ? <Distance>{`${userVirtualRace.distance}KM`}</Distance> : <Distance>{formatDistances(virtualRace.distances)}</Distance>}
            </div>
            <div>
              <Label>Quando correr</Label>
              <Distance>{`${format(new Date(virtualRace.startDate), 'dd/MM')} a ${format(new Date(virtualRace.endDate), 'dd/MM')}`}</Distance>
            </div>
          </InfoContainer>
        </HeaderContainer>
      </Container>
    </>
  );
}
